import { ElementShowImages } from "../../../features/base/image/list/ElementShowImages";
import { ObjectTarget } from "../../../app/permissions";

interface ClassroomImagesProps {
  schoolId: string;
  classroomId: string;
  canDeleteImage: boolean;
}

const ClassroomImages = (props: ClassroomImagesProps) => {
  return <ElementShowImages
    request={{
      targetType: ObjectTarget.CLASSROOM,
      targetId: props.classroomId,
    }}
    toolbar={{
      label: "Imagens",
    }}
    messages={{
      empty: "Não há imagens da sala de aula",
      error: "Erro ao carregar imagens"
    }}
    schoolId={props.schoolId}
    canDelete={props.canDeleteImage}
  />;

};

export default ClassroomImages;